import '@accessible360/accessible-slick';

export const OurValues = (() => {
	'use strict';

	let $values;

	const PXConstants = window.PXConstants;

	function init() {
		$values = $('.pxblock--our-values__values');
		if (!$values) return;

		$values.each(function () {
			renderValuesCarousel(this);
		});
	}

	function renderValuesCarousel(el) {
		$(el).slick({
			infinite: false,
			dots: true,
			arrows: true,
			speed: 400,
			// cssEase: 'linear',
			// autoplay: false,
			// autoplaySpeed: 0,
			slide: 'div',
			focusOnSelect: true,
			pauseOnHover: false,
			// slidesToShow: 2,
			variableWidth: true,
			slidesToScroll: 1,
			prevArrow: '',
			nextArrow:
				'<button class="slick-next" type="button">' +
				'<span class="slick-next-icon" aria-hidden="true">' +
				'<img src="' +
				PXConstants.themeDir +
				'/assets/images/arrow.svg"/>' +
				'</span>' +
				'<span class="slick-sr-only">Next</span>' +
				'</button>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						// slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	}

	return {
		init: init,
		name: 'our-values',
	};
})();
